<template>
  <div class="content">
    <p>《医疗器械标准管理办法》已于2017年2月21日经国家食品药品监督管理总局局务会议审议通过，现予公布，自2017年7月1日起施行。</p>
    <div class="title">
      <p>局长：毕井泉</p>
      <p>2017年4月17日</p>
      <p class="strong">医疗器械标准管理办法</p>
    </div>
    <div class="criterion">
      <!-- 第一章 -->
      <p class="strong">第一章总则</p>
      <p><strong>第一条</strong>为促进科学技术进步，保障医疗器械安全有效，提高健康保障水平，加强医疗器械标准管理，根据《中华人民共和国标准化法》《中华人民共和国标准化法实施条例》和《医疗器械监督管理条例》等法律法规，制定本办法。</p>
      <p><strong>第二条</strong>本办法所称医疗器械标准，是指由国家食品药品监督管理总局依据职责组织制修订，依法定程序发布，在医疗器械研制、生产、经营、使用、监督管理等活动中遵循的统一的技术要求。</p>
      <p><strong>第三条</strong>在中华人民共和国境内从事医疗器械标准的制修订、实施及监督管理，应当遵守法律、行政法规及本办法的规定。</p>
      <p><strong>第四条</strong>医疗器械标准按照其效力分为强制性标准和推荐性标准。对保障人体健康和生命安全的技术要求，应当制定为医疗器械强制性国家标准和强制性行业标准。对满足基础通用、与强制性标准配套、对医疗器械产业起引领作用等需要的技术要求，可以制定为医疗器械推荐性国家标准和推荐性行业标准。</p>
      <p><strong>第五条</strong>医疗器械标准按照其规范对象分为基础标准、方法标准、管理标准和产品标准。</p>
      <p><strong>第六条</strong>国家食品药品监督管理总局依法编制医疗器械标准规划，建立医疗器械标准管理工作制度，健全医疗器械标准管理体系。</p>
      <p><strong>第七条</strong>鼓励企业、社会团体、教育科研机构及个人广泛参与医疗器械标准制修订工作，并对医疗器械标准执行情况进行监督。</p>
      <p><strong>第八条</strong>鼓励参与国际标准化活动，参与制定和采用国际医疗器械标准。</p>
      <p><strong>第九条</strong>国家食品药品监督管理总局对在医疗器械标准工作中做出显著成绩的组织和个人，按照国家有关规定给予表扬和奖励。</p>
      <!-- 第二章 -->
      <h4>第二章标准管理职责</h4>
      <p>
        <strong>第十条</strong>国家食品药品监督管理总局履行下列职责：
        <em>（一）组织贯彻医疗器械标准管理相关法律、法规，制定医疗器械标准管理工作制度；</em>
        <em>（二）组织拟定医疗器械标准规划，编制标准制修订年度工作计划；</em>
        <em>（三）依法组织医疗器械标准制修订，发布医疗器械行业标准；</em>
        <em>（四）依法指导、监督医疗器械标准管理工作。</em>
      </p>
      <p>
        <strong>第十一条</strong>国家食品药品监督管理总局医疗器械标准管理中心（以下简称"医疗器械标准管理中心"）履行下列职责：
        <em>（一）组织开展医疗器械标准体系的研究，拟定医疗器械标准规划草案和标准制修订年度工作计划建议；</em>
        <em>（二）依法承担医疗器械标准制修订的管理工作；</em>
        <em>（三）依法承担医疗器械标准化技术委员会的管理工作；</em>
        <em>（四）承担医疗器械标准宣传、培训的组织工作；</em>
        <em>（五）组织对标准实施情况进行调研，协调解决标准实施中的重大技术问题；</em>
        <em>（六）承担医疗器械国际标准化活动和对外合作交流的相关工作；</em>
        <em>（七）承担医疗器械标准信息化工作，组织医疗器械行业标准出版；</em>
        <em>（八）承担国家食品药品监督管理总局交办的其他标准管理工作。</em>
      </p>
      <p>
        <strong>第十二条</strong>国家食品药品监督管理总局根据医疗器械标准化工作的需要，经批准依法组建医疗器械标准化技术委员会。医疗器械标准化技术委员会履行下列职责：
        <em>（一）开展医疗器械标准研究工作，提出本专业领域标准发展规划、标准体系意见；</em>
        <em>（二）承担本专业领域医疗器械标准起草、征求意见、技术审查等组织工作，并对标准的技术内容和质量负责；</em>
        <em>（三）承担本专业领域医疗器械标准的技术指导工作，协助解决标准实施中的技术问题；</em>
        <em>（四）负责收集、整理本专业领域的医疗器械标准资料，并建立技术档案；</em>
        <em>（五）负责本专业领域医疗器械标准实施情况的跟踪评价</em>
        <em>（六）负责本专业领域医疗器械标准技术内容的咨询和解释</em>
        <em>（七）承担本专业领域医疗器械标准的宣传、培训、学术交流和相关国际标准化活动。</em>
      </p>
      <p><strong>第十三条</strong>在现有医疗器械标准化技术委员会不能覆盖的专业技术领域，国家食品药品监督管理总局可以根据监管需要，按程序确定医疗器械标准化技术归口单位。标准化技术归口单位参照医疗器械标准化技术委员会的职责和有关规定开展相应领域医疗器械标准工作。</p>
      <p>
        <strong>第十四条</strong>地方食品药品监督管理部门在本行政区域依法履行下列职责：
        <em>（一）组织贯彻医疗器械标准管理的法律法规；</em>
        <em>（二）组织、参与医疗器械标准的制修订相关工作；</em>
        <em>（三）监督医疗器械标准的实施；</em>
        <em>（四）收集并向上一级食品药品监督管理部门报告标准实施过程中的问题。</em>
      </p>
      <p><strong>第十五条</strong>医疗器械研制机构、生产经营企业和使用单位应当严格执行医疗器械强制性标准。鼓励医疗器械研制机构、生产经营企业和使用单位积极研制和采用医疗器械推荐性标准，积极参与医疗器械标准制修订工作，及时向有关部门反馈医疗器械标准实施问题和提出改进建议。</p>
      <!-- 第三章 -->
      <h4>第三章标准制定与修订</h4>
      <p><strong>第十六条</strong>医疗器械标准制修订程序包括标准立项、起草、征求意见、技术审查、批准发布、复审和废止等。具体规定由国家食品药品监督管理总局制定。对医疗器械监管急需制修订的标准，可以按照国家食品药品监督管理总局规定的快速程序开展。</p>
      <p><strong>第十七条</strong>医疗器械标准管理中心应当根据医疗器械标准规划，向社会公开征集医疗器械标准制定、修订立项提案。对征集到的立项提案，由相应的医疗器械标准化技术委员会（包括标准化技术归口单位，下同）进行研究后，提出本专业领域标准计划项目立项申请。涉及两个或者两个以上医疗器械标准化技术委员会的标准计划项目立项提案，应当由医疗器械标准管理中心负责协调，确定牵头医疗器械标准化技术委员会，并由其提出标准计划项目立项申请。</p>
      <p><strong>第十八条</strong>医疗器械标准管理中心对医疗器械标准计划项目立项申请，经公开征求意见并组织专家论证后，提出医疗器械标准计划项目，编制标准制修订年度工作计划建议，报国家食品药品监督管理总局审核。国家食品药品监督管理总局审核通过的医疗器械标准计划项目，应当向社会公示。国家标准计划项目送国务院标准化行政主管部门批准下达；行业标准计划项目由国家食品药品监督管理总局批准下达。</p>
      <p><strong>第十九条</strong>医疗器械生产经营企业、使用单位、监管部门、检测机构以及有关教育科研机构、社会团体等，可以向承担医疗器械标准计划项目的医疗器械标准化技术委员会提出起草相关医疗器械标准的申请。医疗器械标准化技术委员会结合标准的技术内容，按照公开、公正、择优的原则，选定起草单位。起草单位应当广泛调研、深入分析研究，积极借鉴相关国际标准，在对技术内容进行充分验证的基础上起草医疗器械标准，形成医疗器械标准征求意见稿，经医疗器械标准化技术委员会初步审查后，报送医疗器械标准管理中心。</p>
      <p><strong>第二十条</strong>医疗器械标准征求意见稿在医疗器械标准管理中心网站向社会公开征求意见，征求意见的期限一般为两个月。承担医疗器械标准计划项目的医疗器械标准化技术委员会对征集到的意见进行汇总后，反馈给标准起草单位，起草单位应当对汇总意见进行认真研究，对征求意见稿进行修改完善，形成医疗器械标准送审稿。</p>
      <p><strong>第二十一条</strong>承担医疗器械标准计划项目的医疗器械标准化技术委员会负责组织对医疗器械标准送审稿进行技术审查。审查通过后，将医疗器械标准报批稿、实施建议及相关资料报送医疗器械标准管理中心进行审核。</p>
      <p><strong>第二十二条</strong>医疗器械标准管理中心将审核通过后的医疗器械标准报批稿及审核结论等报送国家食品药品监督管理总局审查。审查通过的医疗器械国家标准送国务院标准化行政主管部门批准、发布；审查通过的医疗器械行业标准由国家食品药品监督管理总局确定实施日期和实施要求，以公告形式发布。医疗器械国家标准、行业标准按照国务院标准化行政主管部门的相关规定进行公开，供公众查阅。</p>
      <p><strong>第二十三条</strong>医疗器械标准批准发布后，因个别技术内容影响标准使用、需要进行修改，或者对原标准内容进行少量增减时，应当采用标准修改单方式修改。标准修改单应当按照标准制修订程序制定，由医疗器械标准的原批准部门审查发布。</p>
      <p><strong>第二十四条</strong>医疗器械标准化技术委员会应当对已发布实施的医疗器械标准开展复审工作，根据科学技术进步、产业发展以及监管需要对其有效性、适用性和先进性及时组织复审，提出复审结论。复审结论分为继续有效、修订或者废止。复审周期原则上不超过5年。医疗器械标准复审结论由医疗器械标准管理中心审核通过后，报送国家食品药品监督管理总局审查。医疗器械国家标准复审结论，送国务院标准化行政主管部门批准；医疗器械行业标准复审结论由国家食品药品监督管理总局审查批准，并对复审结论为废止的标准以公告形式发布。</p>
      <!-- 第四章 -->
      <h4>第四章标准实施与监督</h4>
      <p><strong>第二十五条</strong>医疗器械企业应当严格按照经注册或者备案的产品技术要求组织生产，保证出厂的医疗器械符合强制性标准以及经注册或者备案的产品技术要求。</p>
      <p><strong>第二十六条</strong>医疗器械推荐性标准被法律法规、规范性文件及经注册或者备案的产品技术要求引用的内容应当强制执行。</p>
      <p><strong>第二十七条</strong>医疗器械产品技术要求，应当与产品设计特性、预期用途和质量控制水平相适应，并不得低于产品适用的强制性国家标准和强制性行业标准。</p>
      <p><strong>第二十八条</strong>食品药品监督管理部门对医疗器械企业实施医疗器械强制性标准以及经注册或者备案的产品技术要求的情况进行监督检查。</p>
      <p><strong>第二十九条</strong>任何单位和个人有权向食品药品监督管理部门举报或者反映违反医疗器械强制性标准以及经注册或者备案的产品技术要求的行为。收到举报或者反映的部门，应当及时按规定作出处理。</p>
      <p><strong>第三十条</strong>医疗器械标准实行信息化管理，标准立项、发布、实施等信息应当及时向公众公开。</p>
      <p><strong>第三十一条</strong>食品药品监督管理部门应当在医疗器械标准发布后，及时组织、指导标准的宣传、培训。</p>
      <p><strong>第三十二条</strong>医疗器械标准化技术委员会对标准的实施情况进行跟踪评价。医疗器械标准管理中心根据跟踪评价情况对强制性标准实施情况进行统计分析。</p>
      <!-- 第五章 -->
      <h4>第五章附则</h4>
      <p><strong>第三十三条</strong>医疗器械国家标准的编号按照国务院标准化行政主管部门的规定编制。医疗器械行业标准的代号由大写汉语拼音字母等构成。强制性行业标准的代号为"YY／Ｔ"。行业标准的编号由行业标准的代号、标准号和标准发布的年号构成。其形式为：YY××××1-××××2和YY／Ｔ××××1-××××2。××××1为标准号，××××2为标准发布年号。</p>
      <p><strong>第三十四条</strong>依法成立的社会团体可以制定发布团体标准。团体标准的管理应当符合国家相关规定。</p>
      <p><strong>第三十五条</strong>医疗器械标准样品是医疗器械检验检测中的实物标准，其管理应当符合国家有关规定。</p>
      <p><strong>第三十六条</strong>本办法自2017年7月1日起施行。2002年1月4日发布的《医疗器械标准管理办法（试行）》（原国家药品监督管理局令第31号）同时废止。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabMedicalDevice'
}
</script>

<style lang="scss" scoped>
.content{
  font-size: 18px;
  color: #6a6a6a;
  p{
    line-height: 36px;
  }
  .title{
    p{
      text-align: center;
      padding-top: 30px;
    }
    .strong{
      color: #434343;
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 18px;
    }
  }
  .criterion{
    margin-top: 20px;
    .strong{
      color: #434343;
      font-size: 20px;
      font-weight: 700;
      text-align: center;
    }
    p{
      font-size: 18px;
      line-height: 36px;
      text-indent:40px;
      strong{
        padding-right: 10px;
      }
      em{
        display: block;
      }
    }
  }
}
</style>
